<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img
                    :src="item.img"
                    class="slider_img"
                    :style="{ height: computeHeight }"
                    @click="clickBanner(item)"
                />
            </el-carousel-item>
        </el-carousel>
        <div class="solve head-label">
            <div class="f-label font_size_30">公司简介</div>
            <div class="s-label font_size_14">PROFILE</div>
            <div class="more-img" @click="$router.push({ name: 'Profile' })" />
        </div>
        <!-- 盒子 -->
        <div class="border_parent">
            <p class="profile-text">
                公司创立于2022年11月，是邮你采联合行业专家及互联网技术精英团队共同注资成立，致力于成为一家创新型医药科技公司。
                邮你采倡导“原厂原标、一店发全国”的工业直销模式，努力缩短工业与终端的距离，为推进健康中国战略贡献力量。
                公司利用先进的商业模式和强大的技术力量，实现了药品全流程数字化追踪。
                通过专业的医药数字化交易服务平台，连接供需两端，推动医疗健康生态系统的进步。
                以业务创新和技术革新为双轮驱动力，重塑医药流通价值链，致力于构建一个医药流通无界交融的新格局。
            </p>
            <el-row :gutter="10">
                <el-col
                    v-for="(item, index) in profile"
                    :key="index"
                    :xs="6"
                    :sm="6"
                    :md="6"
                    style="display: flex; flex-direction: column; align-items: center"
                >
                    <div class="profile-datas-box">
                        <img :src="item.img" class="img" />
                        <div>
                            <div class="font_size_30">{{ item.content }}</div>
                            <div class="font_size_14 grey">{{ item.title }}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="seen" :gutter="20" style="margin-top: 30px">
                <el-col v-for="(item, index) in images" :key="index" :xs="24" :sm="8" :md="8">
                    <div class="border">
                        <div
                            v-show="item.show"
                            class="border-not-cursor"
                            @mouseenter="item.show = false"
                            @mouseleave="item.show = true"
                        >
                            <img :src="item.img" class="img-border" />
                            <div class="border-title">{{ item.title }}</div>
                        </div>
                        <div
                            v-show="!item.show"
                            class="border-cursor"
                            @mouseenter="item.show = false"
                            @mouseleave="item.show = true"
                        >
                            <div class="border-title">{{ item.title }}</div>
                            <div class="border-content">{{ item.content }}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row v-else :gutter="20" style="margin-top: 30px">
                <el-col v-for="(item, index) in images" :key="index" :xs="24" :sm="24" :md="8">
                    <div class="border">
                        <div class="border-cursor">
                            <div class="border-title">{{ item.title }}</div>
                            <div class="border-content">{{ item.content }}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 手机端商品展示 -->
        <div id="产品介绍" class="solve head-label" style="background-color: #f8f8f8">
            <div class="f-label font_size_30">产品介绍</div>
            <div class="s-label font_size_14">PRODUCT</div>
        </div>
        <div class="product">
            <div v-for="(item, index) in productList" :key="index" class="product-item">
                <img :src="item.img" class="product-item-img" />
                <div class="title-content">
                    <div class="title">{{ item.title }}</div>
                    <div class="content">{{ item.content }}</div>
                </div>
                <!-- <div v-if="seen" class="more-img" @click="$router.push({ name: 'Product' })" /> -->
                <div v-if="seen" class="more-img" />
            </div>
        </div>

        <div id="我们的优势" class="solve head-label">
            <div class="f-label font_size_30">我们的优势</div>
            <div class="s-label font_size_14">ADVANTAGE</div>
        </div>
        <div v-if="seen" class="advantage">
            <div v-for="(item, index) in advantageList" :key="index" class="advantage-item">
                <div class="advantage-item-title">
                    <img :src="item.img" class="advantage-item-title-img" />
                    <div class="title" v-html="item.title"></div>
                </div>
                <div class="advantage-item-content">{{ item.content }}</div>
            </div>
        </div>
        <el-carousel v-else :interval="4000" type="card" height="170px" class="advantage-carousel">
            <el-carousel-item v-for="(item, index) in advantageList" :key="index">
                <div class="advantage-item">
                    <div class="advantage-item-title">
                        <img :src="item.img" class="advantage-item-title-img" />
                        <div class="title" v-html="item.title"></div>
                    </div>
                    <div class="advantage-item-content">{{ item.content }}</div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
import { request } from '@/api/auth'
export default {
    name: 'HomePage',
    data() {
        return {
            profile: [
                {
                    img: require('../../assets/main/icon_sec2_1@2x.png'),
                    content: '100+',
                    title: '入驻工业'
                },
                {
                    img: require('../../assets/main/icon_sec2_2@2x.png'),
                    content: '20万+',
                    title: '入驻终端'
                },
                {
                    img: require('../../assets/main/icon_sec2_3@2x.png'),
                    content: '1000+',
                    title: '热销单品'
                },
                {
                    img: require('../../assets/main/icon_sec2_4@2x.png'),
                    content: '2000+',
                    title: '地推人员'
                }
            ],
            images: [
                {
                    img: require('../../assets/main/pic_1@2x.png'),
                    show: true,
                    title: '流通透明化',
                    content:
                        '终端和工业通过邮你采平台直接对接，保证终端获得一手货源，同时工业可以 查看药品流通数据，使药品流通更透明。'
                },
                {
                    img: require('../../assets/main/pic_2@2x.png'),
                    show: true,
                    title: '渠道正规化',
                    content:
                        '邮你采平台的药品均系工业直销，种类相较其他平台更为全面，药品质量更有保证。'
                },
                {
                    img: require('../../assets/main/pic_3@2x.png'),
                    show: true,
                    title: '定价市场化',
                    content:
                        '中间商的减少，有效避免囤货居奇，哄抬药价的现象，将药品的定价权回归工业，保障终端和工业双方利益。'
                }
            ],
            productList: [
                {
                    img: require('../../assets/main/logo_ync_w@2x.png'),
                    title: '面向终端用户App/小程序/网站',
                    content:
                        '面向终端客户提供的一站式医药采购服务终端，实现了终端注册登录、资质审核、商品采购、订单支付、售后申请一条龙服务流程。'
                },
                {
                    img: require('../../assets/main/logo_ydp_w@2x.png'),
                    title: '面向生产工业App/小程序/网站',
                    content:
                        '定位为商家运营服务平台，旨在为工业店铺运营提供便捷的通道，随时随地掌控店铺经营状况，提升店铺运营效率与企业盈利能力。'
                },
                {
                    img: require('../../assets/main/logo_yyw_w@2x.png'),
                    title: '面向业务员App/小程序',
                    content:
                        '专门为业务推广团队打造的一款营销服务工具，实现了业务员入驻申请、绑定终端、业务推广、合作签约、分佣提现完整业务流程。'
                }
                // {
                //     img: require('../../assets/main/logo_yfb_w@2x.png'),
                //     title: '面向终端用户App/小程序',
                //     content: '终端通过邮你采平台采购药品，以邮福宝作为授信支付结算工具，并将授信纳入征信体系。银行根据终端征信情况及采购明细，先行向工业垫付货款，既保证终端正常经营，又帮助工业快速回笼资金。'
                // }
            ],
            advantageList: [
                {
                    img: require('../../assets/main/icon_sec4_1@2x.png'),
                    title: '工业一店发全国，<br>只做原厂原标',
                    content: '工业直销，缩减环节，价格统一，稳控市场，保障货源。'
                },
                {
                    img: require('../../assets/main/icon_sec4_2@2x.png'),
                    title: '商业模式与产业布局',
                    content:
                        '【交易】精炼供应链，桥接供需两端，构建工业直销平台;【流通】实现商城无缝对接，智能化仓储系统;【营销】融合新媒体营销策略，激发行业活力，推动商业模式革新。'
                },
                {
                    img: require('../../assets/main/icon_sec4_3@2x.png'),
                    title: '专业领军与技术驱动',
                    content:
                        '凭借行业专家的卓越领导和企业超强的互联网基因，结合线上线下运营专长，构建了全面的风险防控与质量管理框架，借鉴成功的互联网发展理念，培育独特的发展视角和创新思维。'
                },
                {
                    img: require('../../assets/main/icon_sec4_4@2x.png'),
                    title: '数字化营销服务矩阵',
                    content:
                        '紧随数字化浪潮，打造一体化数字化营销服务工具，融合线下营销精英力量，全方位推进营销战略，建立全渠道推广网络，为药企提供全面的供应链服务，实现精准客户营销。'
                },
                {
                    img: require('../../assets/main/icon_sec4_5@2x.png'),
                    title: '地推服务体系',
                    content:
                        '平台有效衔接工业、业务员、终端三者关系，首推客户本地贴心服务，搭建工业与业务团队合作桥梁，重塑产业价值链。'
                },
                {
                    img: require('../../assets/main/icon_sec4_6@2x.png'),
                    title: '特色技术加持',
                    content:
                        '构建工业、商业、终端全流程电子资质认证体系，是唯一一家实现医药全产业链电子签章的电商平台，为行业监管提供典型案例参考。'
                }
            ],
            timer: null,
            screenWidth: document.body.clientWidth,
            slidersWeb: [],
            slidersMobile: []
        }
    },
    mounted() {
        const _this = this
        window.onresize = () => {
            return (() => {
                _this.screenWidth = document.body.clientWidth
            })()
        }
        this.getNewImage()
    },
    computed: {
        //计算高度
        computeHeight() {
            const m = 700 / 1920
            const mm = 210 / 375
            if (this.screenWidth > 768) {
                return (this.screenWidth * m).toFixed(2) + 'px'
            } else {
                return (this.screenWidth * mm).toFixed(2) + 'px'
            }
        },
        seen() {
            // 屏幕尺寸
            let screenWidth = document.body.clientWidth
            if (screenWidth > 768) {
                return true
            } else {
                return false
            }
        },
        sliders() {
            let screenWidth = document.body.clientWidth
            // let arr = []
            if (screenWidth > 768) {
                // arr = [
                //     {
                //         img: require('../../assets/banner/xinwen.png'),
                //         url: 'https://mp.weixin.qq.com/s/0GbIPgoy1A77tSvK7_uOCw'
                //     },
                //     {
                //         img: require('../../assets/banner/banner6.png'),
                //         url: 'https://yjj.scjgj.fujian.gov.cn/zwgk/xwdt/sjdt1/202403/t20240328_6421264.htm'
                //     },
                //     {
                //         img: require('../../assets/banner/banner.png')
                //     },
                //     {
                //         img: require('../../assets/banner/banner2.png')
                //     },
                //     {
                //         img: require('../../assets/banner/banner3.png')
                //     }
                // ]
                return this.slidersWeb
            } else {
                // arr = [
                //     {
                //         img: require('../../assets/banner/xinwen@2x.png'),
                //         url: 'https://mp.weixin.qq.com/s/0GbIPgoy1A77tSvK7_uOCw'
                //     },
                //     {
                //         img: require('../../assets/banner/banner6@2x.png'),
                //         url: 'https://yjj.scjgj.fujian.gov.cn/zwgk/xwdt/sjdt1/202403/t20240328_6421264.htm'
                //     },
                //     {
                //         img: require('../../assets/banner/banner@2x.png')
                //     },
                //     {
                //         img: require('../../assets/banner/banner2@2x.png')
                //     },
                //     {
                //         img: require('../../assets/banner/banner3@2x.png')
                //     }
                // ]
                return this.slidersMobile
            }
        }
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        backTop() {
            //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 30)
        },

        // 点击banner事件
        clickBanner(item) {
            if (item.textContent) {
                if (item.textContent === '0' && item.text) {
                    // 超链接
                    window.open(item.text)
                } else if (item.textContent === '1') {
                    this.$router.push({ name: 'NewsDetail', params: { id: item.id } })
                }
            }
        },

        getNewImage() {
            request
                .get('/szg-admin/common/news/publicList', {
                    params: {
                        pageNum: 1,
                        pageSize: 10
                    }
                })
                .then((response) => {
                    const { data } = response
                    if (data) {
                        this.slidersWeb = data.map((item) => {
                            return {
                                img: item.publicImg,
                                ...item
                            }
                        })
                        this.slidersMobile = data.map((item) => {
                            return {
                                img: item.publicPhoneImg,
                                ...item
                            }
                        })
                    }
                })
        }
    }
}
</script>

<style scoped lang="scss">
.more-img:hover {
    cursor: pointer;
    background-image: url('../../assets/main/pic_more_nor_active@2x.png') !important;
    background-size: 100% 100%;
}
.border_parent {
    width: 62%;
    // min-width: 1138px;
    margin: auto;
    padding-bottom: 45px;
    padding-left: 20px;
    padding-right: 20px;
}

.profile-text {
    font-weight: 1rem;
    line-height: 28px;
}

.profile-datas-box {
    color: #528274;
    display: flex;
    align-items: center;
    margin-top: 28px;
    img {
        width: 76px;
        height: 76px;
        margin-right: 17px;
        // margin-left: 37px;
    }
}

.slider_img {
    height: 700px;
    width: 100%;
}

.solve {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 15px;
    position: relative;
    .f-label {
        text-align: center;
        color: #157e3b;
    }

    .s-label {
        text-align: center;
        color: #aaaaaa;
        margin-top: 10px;
    }

    .more-img {
        position: absolute;
        right: 19%;
        top: 65px;
        width: 77px;
        height: 32px;
        background-image: url('../../assets/main/pic_more_nor@2x.png');
        background-size: 100% 100%;
    }
}

.border {
    .border-not-cursor {
        position: relative;
        height: 180px;
        .img-border {
            width: 100%;
            height: 100%;
        }
        .border-title {
            position: absolute;
            bottom: 0px;
            left: 0;
            width: 100%;
            height: 40px;
            background: rgba(47, 148, 88, 0.71);
            text-align: center;
            font-size: 1.125rem;
            color: #ffffff;
            line-height: 40px;
        }
    }

    .border-cursor {
        background-color: #2f9458;
        height: 128px;
        padding: 26px 30px;

        .border-title {
            width: 100%;
            font-size: 1.25rem;
            font-weight: bold;
            color: #ffffff;
            line-height: 28px;
            position: relative;
            padding-left: 14px;

            &:before {
                content: '';
                background: #ffffff;
                width: 6px;
                height: 20px;
                position: absolute;
                top: 5px;
                left: 0;
            }
        }

        .border-content {
            font-size: 1rem;
            color: #ffffff;
            line-height: 28px;
            margin-top: 10px;
        }
    }
}

.product {
    background-color: #f8f8f8;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 78px;

    .product-item {
        // height: 160px;
        padding: 30px 0;
        // width: 1000px;
        width: 53%;
        min-width: 800px;
        background: #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.26);
        border-radius: 11px;
        margin: 0 auto;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        position: relative;

        &-img {
            width: 100px;
            height: 100px;
            margin-left: 40px;
            margin-right: 35px;
        }
        .title-content {
            // height: 100px;
            // width: 600px;
            width: calc(100% - 400px);
            .title {
                font-size: 1.25rem;
                font-weight: bold;
                color: #2f9458;
                line-height: 28px;
            }

            .content {
                font-size: 0.875rem;
                color: #666666;
                line-height: 24px;
                margin-top: 10px;
            }
        }

        .more-img {
            width: 76px;
            height: 32px;
            position: absolute;
            right: 30px;
            top: 50%;
            transform: translate(0, -50%);
            background-image: url('../../assets/main/pic_more_nor@2x.png');
            background-size: 100% 100%;
        }
    }
}

.advantage {
    width: 60%;
    min-width: 1121px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 5px 20px 14px 20px;
    &-item {
        width: calc(33% - 100px);
        background: #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.26);
        border-radius: 8px;
        position: relative;
        margin-bottom: 32px;
        padding: 16px 19px 16px 31px;

        &-title {
            display: flex;
            align-items: center;
            &-img {
                width: 44px;
                height: 44px;
                margin-right: 12px;
            }
            .title {
                font-size: 1.125rem;
                font-weight: bold;
                color: #000000;
                line-height: 25px;
            }
        }

        &-content {
            font-size: 0.875rem;
            color: #000000;
            line-height: 20px;
            margin-top: 12px;
        }

        &:before {
            content: '';
            width: 8px;
            height: 100%;
            background: #157e3b;
            position: absolute;
            top: 0;
            left: 0;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
        }
    }
}

.border_one {
    margin-left: 0;
}

.border_img_parent {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.product_mobile_content {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.product_mobile_img {
    width: 50%;
}

.product_mobile_title {
    font-weight: bold;
    text-align: center;
}

.product_pc_one {
    text-align: center;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.font_size_30 {
    font-size: 1.875em;
}

.product_font_style {
    font-size: 1.125em;
}

.product_pc_img {
    width: 100%;
}

.product_pc_img_div {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
}

.product_pc {
    display: flex;
    width: 90%;
    margin: 20px auto;
    background: #f2f6fc;
    align-items: center;
}

.product_spec_title {
    margin-top: 30px;
    margin-bottom: 10px;
}

.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto;
}

.cooperation_parent {
    display: flex;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto;
}

.border_spec {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 25%;
    height: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
    font-size: 1.25em;
    font-weight: normal;
    padding: 0 20px;
    margin: 10px;
}

.border_title {
    font-family: 'PingFang SC';
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
}

.border_content_one {
    margin-top: 20px;
    font-size: 1.125em;
    text-align: center;
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
    text-align: center;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px;
}

.border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
    height: 70px;
}

.border_spec_content_one {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    text-align: center;
}

.border_spec_inner_last {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 25px;
    text-align: center;
}

.cooperation {
    margin-top: 30px;
    width: 100%;
}

.about_me {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    background: #f2f6fc;
}

.product_mobile_img_div {
    width: 50%;
    height: auto;
}

.product_mobile_content_one {
    margin-top: 20px;
    text-align: center;
}

.product_mobile_content_two {
    margin-top: 10px;
    text-align: center;
}

.border_spec_img {
    width: 75px;
    height: 55px;
    align-self: center;
}

.font_size_30 {
    font-size: 1.875rem;
}

.font_size_14 {
    font-size: 0.875rem;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 768px) {
    ::v-deep .el-carousel__button {
        width: 12px;
    }
    .slider_img {
        height: 210px;
        width: 100%;
    }

    .font_size_30 {
        font-size: 0.9375rem; // 15px
    }

    .font_size_14 {
        font-size: 0.625rem; // 10px
    }

    .solve {
        width: 100%;
        padding-top: 14px;
        padding-bottom: 14px;
        position: relative;
        .f-label {
            text-align: center;
            color: #157e3b;
        }

        .s-label {
            text-align: center;
            color: #aaaaaa;
            margin-top: 6px;
        }

        .more-img {
            position: absolute;
            right: 16px;
            top: 20px;
            width: 48px;
            height: 20px;
            background-image: url('../../assets/main/pic_more_nor@2x.png');
            background-size: 100% 100%;
        }
    }

    .border_parent {
        width: calc(100% - 32px);
        padding: 0 16px 10px 16px;
        .profile-text {
            margin: 0;
        }

        .profile-datas-box {
            flex-direction: column;
            align-items: center;

            .img {
                width: 45px;
                height: 45px;
                margin: 0 auto;
            }
            .grey {
                color: #999999;
            }
        }

        .border {
            margin-bottom: 10px;
            .border-cursor {
                background-color: #ffffff;
                border-radius: 3px;
                border: 1px solid #2f9458;
                padding: 14px 13px;
                height: auto;

                .border-title {
                    color: #333;
                    font-size: 0.9375rem;
                    padding-left: 10px;
                    height: 21px;
                    line-height: 21px;

                    &:before {
                        background: #2f9458;
                        height: 18px;
                        width: 4px;
                        top: 1px;
                    }
                }

                .border-content {
                    color: #333;
                    font-size: 0.75rem;
                    line-height: 18px;
                    margin-top: 10px;
                }
            }
        }
    }

    .product {
        width: 100%;
        padding-top: 0px;
        padding-bottom: 15px;
        .product-item {
            width: calc(100% - 32px);
            height: auto;
            margin-bottom: 12px;
            min-width: calc(100% - 32px);
            padding: 12px 0;
            .product-item-img {
                width: 70px;
                height: 70px;
                margin-right: 6px;
                margin-left: 10px;
            }
            .title-content {
                width: auto;
                height: auto;
                margin: 12px 10px 12px 0px;
                .title {
                    font-size: 0.875rem;
                    font-weight: bold;
                    color: #2f9458;
                    line-height: 20px;
                }
                .content {
                    font-size: 0.75rem;
                    color: #666666;
                    line-height: 18px;
                    margin-top: 8px;
                }
            }
        }
    }

    .advantage-carousel {
        width: 100%;
        // min-width: 100%;
        // overflow-x: hidden;
        padding: 0;
        .advantage-item {
            width: calc(100% - 40px);
            // width: 245px;
            padding: 10px 13px 16px 21px;
            margin-bottom: 0px;
            height: 130px;
            margin-right: 5px;
            box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.26);
            .advantage-item-title {
                .title {
                    font-size: 1rem;
                    font-weight: bold;
                    line-height: 22px;
                }
            }
            .advantage-item-content {
                font-size: 0.75rem;
                color: #000000;
                line-height: 17px;
                margin-top: 5px;
            }
        }

        .el-carousel__container {
            .el-carousel__item--card {
                // width: calc(100% - 144px);
                min-width: 270px;
                // width: auto;
            }
            .el-carousel__item {
                // width: calc(100% - 142px);
                min-width: 270px;
                // width: auto;
            }
            .el-carousel__item--card.is-active {
                z-index: 2;
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0px) !important;
                transition: transform 0.4s ease-in-out;
            }
        }
    }
}
@media screen and (min-device-width: 769px) and (max-device-width: 1100px) {
    .border_parent {
        width: 90%;
    }

    .solve {
        .more-img {
            right: 5%;
        }
    }
    .advantage {
        width: 90%;
        min-width: auto;
        .advantage-item {
            width: calc(33% - 60px);
        }
    }

    .border {
        .border-cursor {
            height: 164px;
            padding: 8px 15px;
            .border-content {
                margin-top: 0px;
            }
        }
    }
}
</style>
